import { render, staticRenderFns } from "./FactArchive.vue?vue&type=template&id=56e648f6&scoped=true"
import script from "./FactArchive.vue?vue&type=script&lang=js"
export * from "./FactArchive.vue?vue&type=script&lang=js"
import style0 from "./FactArchive.vue?vue&type=style&index=0&id=56e648f6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e648f6",
  null
  
)

export default component.exports